import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import LazyElement from '../extension'

const routes: Readonly<RouteObject[]> = [
  {
    path: '',
    element: <Navigate to="register" />
  },
  {
    path: 'register',
    element: <LazyElement importFunc={() => import('@/views/register')} />
  },
  {
    path: 'icici_pay_result',
    element: <LazyElement importFunc={() => import('@/views/iciciPayResult')} />
  },
  {
    path: 'sn_query',
    element: <LazyElement importFunc={() => import('@/views/snQuery')} />
  }
]

export default routes
